import React from 'react';
import { PageHero, SectionLabel, PrimaryButton, Stat } from '../components/Shared';
import { caseStudies, heroStats, proofPoints, images } from '../data/mock';

const Results = () => {
  return (
    <>
      <PageHero
        eyebrow="תוצאות והוכחות בשטח"
        title="תוצאות מודדים בשורת ההכנסות,"
        accent="לא בקליקים."
        subtitle="אנחנו דורשים מעצמנו את אותה רמת מציונות שאתם דורשים מהעסק שלכם. הנה קצת מהרקע והניסיון שמרכיבים את המערכות שלנו."
        image={images.results}
      />

      {/* Stats hero */}
      <section className="py-16 lg:py-20 bg-cream" aria-label="מדדים מרכזיים">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 reveal">
            {heroStats.map((s) => (
              <Stat key={s.label} {...s} />
            ))}
          </div>
        </div>
      </section>

      {/* Proof points */}
      <section className="py-20 lg:py-28 bg-cream-200" aria-labelledby="proof-heading">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mb-16 reveal">
            <SectionLabel>הוכחות, קבלות וניסיון</SectionLabel>
            <h2 id="proof-heading" className="display-2 text-navy">מה שמגדיר את המערכת שלנו.</h2>
          </div>
          <div className="grid lg:grid-cols-2 gap-px bg-navy/10 reveal">
            {proofPoints.map((p, i) => (
              <article key={p.label} className="bg-cream-200 p-8 lg:p-10">
                <div className="flex items-baseline gap-4 mb-4">
                  <span className="font-serif text-3xl text-bronze" aria-hidden="true">0{i + 1}</span>
                  <h3 className="display-3 text-navy">{p.label}</h3>
                </div>
                <p className="lede text-navy/75 text-base lg:text-lg">{p.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Case studies detailed */}
      <section className="py-24 lg:py-32 bg-cream" aria-labelledby="cases-heading">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mb-16 reveal">
            <SectionLabel>מקרי בוחן מובחרים</SectionLabel>
            <h2 id="cases-heading" className="display-2 text-navy">מה שמאחורי המספרים.</h2>
          </div>
          <div className="grid lg:grid-cols-2 gap-8 reveal">
            {caseStudies.map((c) => (
              <article key={c.name} className="lift-card border border-navy/10 p-8 lg:p-12 bg-cream">
                <p className="num-callout text-bronze mb-6" aria-hidden="true">{c.metric}</p>
                <h3 className="display-3 text-navy mb-3">{c.name}</h3>
                <p className="font-serif text-navy/80 mb-5 text-lg">{c.headline}</p>
                <p className="text-navy/70 lede leading-relaxed">{c.body}</p>
              </article>
            ))}
          </div>
          <div className="mt-16 reveal">
            <PrimaryButton to="/contact">לקביעת שיחת אבחון</PrimaryButton>
          </div>
        </div>
      </section>
    </>
  );
};

export default Results;
